<template>
  <tr v-if="!esEditable">
    <template v-if="!estaLiquidado">
      <td class="text-center">
        <button class="btn btn-xs btn-icon btn-light-warning ml-1" @click="onEdit">
          <i class="fa fa-pen"></i>
        </button>
        <button class="btn btn-xs btn-icon btn-light-danger ml-1" @click="onDelete" :disabled="loading.save">
          <i class="fa fa-trash-alt"></i>
        </button>
      </td>
      <td class="text-center sortable-handle">
        <i class="fa fa-arrows-alt-v"></i>
      </td>
    </template>
    <td class="text-center">
      <template>{{ item.fecha | date("YYYY-MM-DD", "ddd DD MMM YY") }}</template>
    </td>
    <td class="text-truncate" :title="item.servicio">
      <template>{{ item.servicio }}</template>
    </td>
    <td>
      <template>{{ item.proveedor }}</template>
    </td>
    <td>
      <template>{{ item.hotel }}</template>
    </td>
    <td class="text-truncate" :title="item.vueloTourTren">
      <template>{{ item.vueloTourTren }}</template>
    </td>
    <td>
      <template>{{ item.guia }}</template>
    </td>
    <td class="text-center">
      <template>{{ item.servicioSigla }}</template>
    </td>
    <td>
      <template>{{ item.restaurante }}</template>
    </td>
    <td>
      <template>{{ item.observaciones }}</template>
    </td>
  </tr>
  <ValidationObserver v-else tag="tr" ref="form" :vid="String(item.idItinerario)">
    <td class="text-center">
      <button class="btn btn-xs btn-icon btn-light-primary" @click="onSave" :disabled="loading.save">
        <i class="fa fa-check"></i>
      </button>
      <button class="btn btn-xs btn-icon btn-secondary ml-1" @click="onRemove" :disabled="loading.save">
        <i class="fa fa-times"></i>
      </button>
    </td>
    <td></td>
    <td>
      <InputDatepicker v-model="item.tempFecha" :errorMode="'tooltip'" :vid="`fecha_${item.idItinerario}`" name="Fecha" rules="required" :editable="false" :inputClass="'form-control form-control-table text-center'"></InputDatepicker>
    </td>
    <td>
      <InputSelect v-model="item.tempServicio" :errorMode="'tooltip'" :vid="`servicio_${item.idItinerario}`" name="Servicio" rules="required" :options="servicios" label="nombre" input-class="form-control-table"></InputSelect>
    </td>
    <td>
      <InputSelect v-model="item.tempProveedor" :errorMode="'tooltip'" :vid="`proveedor_${item.idItinerario}`" name="Proveedor" rules="required" :options="proveedores" label="nombre" input-class="form-control-table"></InputSelect>
    </td>
    <td>
      <InputSelect v-model="item.tempHotel" :errorMode="'tooltip'" :vid="`hotel_${item.idItinerario}`" name="Hotel" :options="hoteles" label="nombre" input-class="form-control-table"></InputSelect>
    </td>
    <td>
      <InputText v-model="item.tempVueloTourTren" :errorMode="'tooltip'" :vid="`vueloTourTren_${item.idItinerario}`" name="Vuelo-Tour-Tren" :inputClass="'form-control form-control-table'"></InputText>
    </td>
    <td>
      <InputSelect v-model="item.tempGuia" :errorMode="'tooltip'" :vid="`guia_${item.idItinerario}`" name="Guía" :options="guias" label="nombre" input-class="form-control-table"></InputSelect>
    </td>
    <td>
      <InputSelect v-if="!!tiposPorServicio.length" v-model="item.tempTipo" :errorMode="'tooltip'" :vid="`tipo_${item.idItinerario}`" name="Tipo" :options="tiposPorServicio" label="sigla" input-class="form-control-table"></InputSelect>
    </td>
    <td>
      <InputSelect v-model="item.tempRestaurante" :errorMode="'tooltip'" :vid="`restaurante_${item.idItinerario}`" name="Restaurante" :options="restaurantes" label="nombre" input-class="form-control-table"></InputSelect>
    </td>
    <td>
      <InputTextArea v-model="item.tempObservaciones" :errorMode="'tooltip'" :vid="`observaciones_${item.idItinerario}`" name="Observaciones" :inputClass="'form-control form-control-table'"></InputTextArea>
    </td>
  </ValidationObserver>
</template>

<script>
// fecha, servicio, proveedor, hotel (campos requeridos)
// tipo es condicional por servicio
// fecha con valor por defecto a this.privado.fechaLlegada ☻
import InputTextArea from "../../shared/components/InputTextArea.vue";
import InputSelect from "../../shared/components/InputSelect.vue";
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import InputText from "../../shared/components/InputText.vue";
import { mapGetters, mapState } from "vuex";

export default {
  components: { InputText, InputDatepicker, InputSelect, InputTextArea },
  props: {
    item: Object,
  },
  data() {
    return {
      loading: {
        save: false,
      },
      containers: {
        servicioWatch: null,
      },
    };
  },
  computed: {
    esEditable() {
      return this.item.isNew || this.item.isEdit;
    },
    tiposPorServicio() {
      const vm = this;
      if (!vm.item.tempServicio) return [];
      return vm.serviciosTipos.filter((item) => item.idServicio == vm.item.tempServicio.idServicio);
    },
    ...mapState("privados", ["agencias", "guias"]),
    ...mapState("privado.itinerario", ["privado", "servicios", "proveedores", "hoteles", "restaurantes", "serviciosTipos"]),
    ...mapGetters("privado.itinerario", ["estaLiquidado"]),
  },
  mounted() {
    this.addWatchToServicio(this.esEditable);
  },
  watch: {
    esEditable(val) {
      this.addWatchToServicio(val);
    },
  },
  methods: {
    async onSave() {
      const vm = this;
      const validated = await this.$refs.form.validate();

      if (!validated) return;

      vm.loading.save = true;

      const fd = {
        fecha: vm.item.tempFecha,
        servicio: vm.item.tempServicio.idServicio,
        proveedor: vm.item.tempProveedor.idProveedor,
        hotel: vm.item.tempHotel?.idHotel || null,
        vueloTourTren: vm.item.tempVueloTourTren || null,
        guia: vm.item.tempGuia?.idPersona || null,
        servicioTipo: vm.item.tempTipo?.idServicioTipo || null,
        restaurante: vm.item.tempRestaurante?.idRestaurante || null,
        observaciones: vm.item.tempObservaciones || null,
      };

      const endpoint = vm.item.isEdit ? vm.axios.put(`/privados/${vm.privado.idPrivado}/itinerario/${vm.item.idItinerario}`, fd) : vm.axios.post(`/privados/${vm.privado.idPrivado}/itinerario`, fd);

      endpoint
        .then((response) => {
          vm.$toast.fire("", response.data.message, "success");

          vm.$store.dispatch("privado.itinerario/saveItem", {
            id: vm.item.idItinerario,
            newId: response.data.content,
          });
        })
        .finally(() => {
          vm.loading.save = false;
        });
    },
    onEdit() {
      this.$store.dispatch("privado.itinerario/editItem", this.item.idItinerario);
    },
    onCancel() {
      this.item.isEdit = false;
    },
    onRemove() {
      if (this.item.isEdit) return this.onCancel();

      this.$store.dispatch("privado.itinerario/removeItem", this.item.idItinerario);
    },
    async onDelete() {
      const vm = this;
      const result = await vm.$confirm.fire("", "¿Estás seguro de eliminar este registro?");
      if (!result.value) return;

      vm.loading.save = true;

      vm.axios
        .delete(`/privados/${vm.privado.idPrivado}/itinerario/${vm.item.idItinerario}`)
        .then((response) => {
          vm.$toast.fire("", response.data.message, "success");
          this.$store.dispatch("privado.itinerario/removeItem", vm.item.idItinerario);
        })
        .catch((err) => {
          vm.loading.save = false;
        });
    },
    addWatchToServicio(val) {

      if (val) {
        if (this.containers.servicioWatch !== null) return;
        this.containers.servicioWatch = this.$watch("item.tempServicio", function() {
          this.item.tempTipo = null;
        });
      } else {
        if (this.containers.servicioWatch !== null) this.containers.servicioWatch();
        this.containers.servicioWatch = null;
      }
    },
  },
};
</script>

<style></style>
